import React from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import PropTypes from "prop-types";
import * as classnames from "classnames";

import IconButton from "@/shared/components/IconButton/IconButton";
import EgwWebFont from "@/shared/assets/EgwWebFont";

import styles from "./PlayerUIKit.module.scss";

export const PlayControls = ({
  disabled,
  isAudioPlaying,
  onSkipPrevClick,
  onSkipNextClick,
  onSeekPrevClick,
  onSeekNextClick,
  onTogglePlayClick,
  isSeekBackDisabled = false,
  isSeekForwardDisabled = false,
  isSkipForwardDisabled = false,
  isSkipBackDisabled = false,
  isTogglePlayDisabled = false,
  showSkipButtons = true,
  showSeekButtons = true,
  className,
  style,
}) => {
  const { t } = useSharedTranslation();
  return (
    <div
      className={classnames(styles["player-controls"], className, {
        [styles["skip-buttons-shown"]]: showSkipButtons,
      })}
      style={style}
    >
      {showSeekButtons && <IconButton
        showIcon
        icon={EgwWebFont["chevron-double-left"]}
        onClick={onSeekPrevClick}
        title={t("seekBack")}
        disabled={disabled || isSeekBackDisabled}
      />}
      {showSkipButtons && (
        <IconButton
          showIcon
          icon={EgwWebFont["skip-back"]}
          onClick={onSkipPrevClick}
          title={t("skipBack")}
          disabled={disabled || isSkipBackDisabled}
        />
      )}
      <IconButton
        showIcon
        icon={isAudioPlaying ? EgwWebFont["pause"] : EgwWebFont["play"]}
        onClick={onTogglePlayClick}
        title={t("isPlaying")}
        disabled={disabled || isTogglePlayDisabled}
      />
      {showSkipButtons && (
        <IconButton
          showIcon
          icon={EgwWebFont["skip-forward"]}
          onClick={onSkipNextClick}
          title={t("skipForward")}
          disabled={disabled || isSkipForwardDisabled}
        />
      )}
      {showSeekButtons && <IconButton
        showIcon
        icon={EgwWebFont["chevron-double-right"]}
        onClick={onSeekNextClick}
        title={t("seekForward")}
        disabled={disabled || isSeekForwardDisabled}
      />}
    </div>
  );
};

PlayControls.propTypes = {
  className: PropTypes.string,
  isAudioPlaying: PropTypes.bool,
  isSeekBackDisabled: PropTypes.bool,
  isSeekForwardDisabled: PropTypes.bool,
  isSkipForwardDisabled: PropTypes.bool,
  isSkipBackDisabled: PropTypes.bool,
  isTogglePlayDisabled: PropTypes.bool,
  disabled: PropTypes.bool,
  showSkipButtons: PropTypes.bool,
  onSkipPrevClick: PropTypes.func,
  onSkipNextClick: PropTypes.func,
  onSeekPrevClick: PropTypes.func,
  onSeekNextClick: PropTypes.func,
  onTogglePlayClick: PropTypes.func,
};

